import createFromIconfontCN from '@ant-design/icons/es/components/IconFont'

export default createFromIconfontCN({
    // 因为ali站点的资源文件有点卡
    // 所以后续icon 都需要放我们自己的cdn
    // 上传工具的地址如下： https://scmops.sursung.com/#/security/tools/uploadOss
    scriptUrl: [
        'https://assets.sursung.com/activity/20241216/3ACF7B37A9164286B1584B01CA8BFD331734355621203.js', // PC
        'https://assets.sursung.com/activity/20231206/1D5EB80F61FD4195AB642C84EE2FA8ED1701858295717.js' // H5
    ]
    // 修改时间：2024/10/24 17:00                                 // h5的 2023/08/14 11:40
})
